<div class="ms-3 mb-2" [ngClass]="inTable? 'mt-0':'mt-3'">
  @if (!inTable) {
    <label>{{radio.name}}</label>
  }
  @if (rowKeyIndex) {
    <fieldset id="{{rowKeyIndex}}">
      @for (radioCh of radio.targets; track radioCh) {
        <div class="form-check">
          <input type="radio" class="form-check-input" name="{{rowKeyIndex}}" value="{{radioCh.key}}"
            [checked]="this.radio?.value===radioCh.key"
            (change)="onChange($event.target.value)">
            <label class="form-check-label" for="{{radioCh.key}}">{{radioCh.name}}</label>
          </div>
        }
      </fieldset>
    }
  </div>
